import { createFileRoute, Outlet } from '@tanstack/react-router';
import { AuthGuard } from '../components/Auth/AuthGuard';
import { AppShell } from '../components/layout/AppShell';

// Layout for /analytics and /analytics/$shareToken. The child routes render
// through the Outlet; without it, navigating to a video showed no detail.
export const Route = createFileRoute('/analytics')({
  component: () => (
    <AuthGuard>
      <AppShell>
        <Outlet />
      </AppShell>
    </AuthGuard>
  ),
});
